import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-set-payment-method',
  templateUrl: './set-payment-method.component.html',
  styleUrl: './set-payment-method.component.scss',
  standalone: false
})
export class SetPaymentMethodComponent {
  processing: any;
  paymentMethods: any[] = [];
  errorMassage!: string;
  Methods: any[] = [];
  constructor(
    private router: Router,
    private userService: UserService,
    private dialogRef: MatDialogRef<SetPaymentMethodComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.paymentMethods = data;
    this.errorMassage = data.errorMassage;
  }

  ngOnInit() {
    this.paymentMethods = [this.paymentMethods];
  }
  cardDefault(method: any) {
    this.processing = true;
    console.log('method[0]', method[0].methods.payment_method_id);
    this.userService.setDefaultPaymentMethod(method[0].methods.payment_method_id, method[0].methods.stripe_customer_id)
      .subscribe({
        next: (values) => {
          this.processing = false;
          console.log('Default payment method set successfully', values);
          this.dialogRef.close({ primaryCard: true });
        }
      });
  }
  Close() {
    this.dialogRef.close('cancelDialog');
    this.router.navigate(['/billing']);
  }
}
